/* istanbul ignore file */
import { array as codecArray, number as codecNumber, oneOf as codecOneOf, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { RubricDescriptionType } from './RubricDescriptionType';
import { RubricItem } from './RubricItem';
import { RubricLockReason } from './RubricLockReason';
const RubricRowBaseParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['header', codecString],
    ['description', /* #__PURE__ */ parsers.maybeNull(codecString)],
    ['descriptionType', RubricDescriptionType, 'description_type'],
    ['items', /* #__PURE__ */ codecArray(RubricItem)],
    [
        'locked',
        /* #__PURE__ */ codecOneOf([RubricLockReason, /* #__PURE__ */ parsers.exactly(false)]),
    ],
    ['type', codecString],
]));
export class RubricRowBase extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return RubricRowBaseParser.decode(input).map(res => new RubricRowBase(res));
    }
    static unsafeDecode(input) {
        return RubricRowBase.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RubricRowBaseParser.encode(data);
    }
    static schema() {
        return RubricRowBaseParser.schema();
    }
}
